import { useEffect, useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { CloseToastButton } from '@/components/generic/Toast/Toast';
import { TOAST_POSITION } from '@/constants';
import { OfflineProvider, RolesAndPermissionProvider, useAuth } from '@/contexts';
import { URL_PARAMS } from '@/enums';
import { useClarityTracking, useLogoutFromQueryParam } from '@/hooks';
import { router } from '@/routes/router';

export const App = () => {
  const { currentUserData, logout } = useAuth();
  const search = window.location.search;
  const urlParams = useMemo(() => new URLSearchParams(search), [search]);
  const hidParam = urlParams.get(URL_PARAMS.HID);

  useClarityTracking(currentUserData);
  useLogoutFromQueryParam(logout, search);

  useEffect(() => {
    if (hidParam) {
      localStorage.setItem(URL_PARAMS.HID, hidParam);
    }
  }, [hidParam]);

  return (
    <div>
      <OfflineProvider>
        <RolesAndPermissionProvider>
          <RouterProvider router={router} />
        </RolesAndPermissionProvider>
      </OfflineProvider>
      <ToastContainer
        hideProgressBar
        newestOnTop={false}
        transition={Slide}
        closeOnClick={false}
        closeButton={CloseToastButton}
        autoClose={3000}
        position={TOAST_POSITION}
      />
    </div>
  );
};
